import { useSwrNoAuth } from "../../swr/useSwrNoAuth";

export const useFetchCustomerVisitCount = (restaurantId: string, lineId: string) => {
  const { data: visitCount, error, isLoading: isLoadingVisitCount } = useSwrNoAuth<number>(`external_api/restaurants/${restaurantId}/line-accounts/${lineId}/visit-count/`)
  return { visitCount, isLoadingVisitCount, error };
};